/**
 * Utility functions for URL conversion and validation
 */

/**
 * Convert YouTube URL to embed format
 */
export function convertYouTubeURL(url: string): string {
  // youtu.be形式対応
  const youtuBeMatch = url.match(/^https?:\/\/(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (youtuBeMatch && youtuBeMatch[1]) {
    return `https://www.youtube.com/embed/${youtuBeMatch[1]}`;
  }

  // 通常のYouTube URL
  const match = url.match(/(?:v=|\/live\/|\/watch\?v=|\/embed\/)([a-zA-Z0-9_-]{11})/);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  return url;
}

/**
 * Convert Vimeo URL to embed format
 */
export function convertVimeoURL(url: string): string {
  try {
    const parsedUrl = new URL(url);
    const segments = parsedUrl.pathname.split('/').filter(Boolean);
    if (segments.length === 0) {
      return url;
    }
    const videoId = segments[0];
    if (!/^\d+$/.test(videoId)) {
      return url;
    }
    let embedUrl = `https://player.vimeo.com/video/${videoId}`;
    if (segments.length > 1 && /^[a-z0-9]+$/i.test(segments[1])) {
      embedUrl += `?h=${segments[1]}`;
    }
    return embedUrl;
  } catch (error) {
    console.error('無効なURLです。:', error);
    return url;
  }
}

/**
 * Get embed URL for supported video services
 */
export function getEmbedURL(url: string): string | undefined {
  if (url.includes('youtube') || url.includes('youtu.be')) {
    return convertYouTubeURL(url);
  } else if (url.includes('vimeo')) {
    return convertVimeoURL(url);
  }

  return undefined;
}

/**
 * Validate URL format
 */
export function isValidUrl(url: string): boolean {
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
  return urlRegex.test(url);
}

/**
 * Check if URL is from supported video service
 */
export function isSupportedVideoService(url: string): boolean {
  const validServices = ['youtube.com', 'youtu.be', 'vimeo.com'];
  return validServices.some((service) => url.includes(service));
}

/**
 * Validate iframe code
 */
export function isValidIframeCode(code: string): boolean {
  const iframeTagRegex = /<iframe.*?>.*?<\/iframe>/i;
  return iframeTagRegex.test(code);
}

/**
 * Check if iframe code is from supported service
 */
export function isSupportedIframeService(code: string): boolean {
  const validServices = ['youtube.com', 'youtu.be', 'vimeo.com', 'facebook.com'];
  return validServices.some((service) => code.includes(service));
}
